module.exports = __webpack_public_path__ + "img/9aa1386.jpg";